<div class="is-vishidden" tabindex="-1" #a11yHeading>
  {{
    'destinationSearch.selectedDestination.' + (selectedDestinations.length === 1 ? 'singular' : 'plural')
      | finLocalization
  }}
</div>
<ul
  *ngIf="selectedDestinations.length"
  class="no-list-style flex flex--wrap flex--middle"
  data-testid="selected-destinations-list"
  #tagsList
>
  <li
    *ngFor="let item of selectedDestinations; let i = index; trackBy: trackByFn"
    class="ms-xsmall-r"
    [style]="(isMobile$ | async) === true ? {} : cmsStylesOverride"
    data-testid="destinations-filter-chips-chip"
  >
    <fcom-chip
      [text]="item.title"
      [title]="('actions.remove' | finLocalization) + ' ' + item.title"
      [iconName]="SvgLibraryIcon.CLOSE_DELETE"
      [theme]="ChipTheme.ACTIVE"
      (tagClicked)="removeChip(item)"
    >
    </fcom-chip>
  </li>
  <li *ngIf="selectedDestinations.length >= 2" [style]="(isMobile$ | async) === true ? {} : cmsStylesOverride">
    <button
      id="remove-all"
      class="btn btn--no-outline nordic-blue-900-text underline font-body-1 ps-xsmall-y"
      (click)="removeAll()"
      data-testid="destinations-filter-chips-remove-all"
    >
      {{ 'destinationSearch.chip.action.removeAll' | finLocalization }}
    </button>
  </li>
</ul>
